
const privilegedPositions = ["owner", "manager"];
const BACKEND_URL = process.env.REACT_APP_API_BASE_URL || "";
const BACKEND_CALL_TIMEOUT = 20000;
export const USER_SIGNIN_TIMEOUT = 30000;
const TIMESHEET_POST_TIMEOUT = 30000;

const LOCATION_NAME_TO_ID = {
    UNSELECTED: 0,
    Hopkins: 1,
    InverGrove: 2
};

const LOCATION_ID_TO_NAME = Object.fromEntries(
    Object.entries(LOCATION_NAME_TO_ID).map(([name, id]) => [id, name])
);

const STEPS = {
    IDENTIFY: 'identify',
    LOCATION: 'location',
    DASHBOARD: 'dashboard'
};

const DEFAULT_INACTIVITY_TIMEOUT_SECONDS = 30;

export { privilegedPositions, BACKEND_URL, BACKEND_CALL_TIMEOUT, TIMESHEET_POST_TIMEOUT, LOCATION_NAME_TO_ID, LOCATION_ID_TO_NAME, STEPS, DEFAULT_INACTIVITY_TIMEOUT_SECONDS };